import React from "react";
import { Paper, Table, TableBody, TableCell } from "@mui/material";
import { TableContainer, TableHead, TableRow } from "@mui/material";
import moment from "moment";
import { ConstructionOutlined } from "@mui/icons-material";

function Purchase({ items, onChange }) {
  console.log('items', items);
  // const quantity = items.items.map((item)=> {
  //   return item.quantity
  // })
  // console.log('io', quantity)
  return (
    <TableContainer component={Paper}>
      <Table aria-label="customized table">
        <TableHead>
          <TableRow>
            <TableCell>Selected</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Ledger</TableCell>
            <TableCell>Quantity</TableCell>
            <TableCell>Paid</TableCell>
            <TableCell>Remaining</TableCell>
            <TableCell>Created</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items?.map((item, i) => {
            const quantity = item?.items?.reduce((sum,item)=> {
    return sum + Number(item?.quantity)
  },0)
  return (
            <TableRow key={i}>
              <TableCell component="th" scope="row">
                <input
                  type="checkbox"
                  defaultChecked=""
                  onChange={() => onChange(item)}
                />
              </TableCell>
              <TableCell component="th" scope="row" className="fs-8">
                {`Purchase Order ${items.length - i}`}
              </TableCell>
              <TableCell component="th" scope="row" className="fs-8">
                {item?.ledger_detail?.name}
              </TableCell>
              <TableCell component="th" scope="row" className="fs-8">
                {quantity}
              </TableCell>
              <TableCell component="th" scope="row" className="fs-8">
                {item?.paid || 0}
              </TableCell>
              <TableCell component="th" scope="row" className="fs-8">
                {item?.remaining || 0}
              </TableCell>
              <TableCell component="th" scope="row" className="fs-8">
                {moment.unix(item?.created_at).format("DD-MM-YYYY")}
              </TableCell>
            </TableRow>
           )
          })}
          
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default Purchase;
